<template>
  <div
    v-if="showAll || worker.vacations.length"
    class="worker-row"
    :data-id="worker.id"
    :class="{
      'worker-row--multiple': periodGroups.length > 1,
    }"
  >
    <div class="worker-row__wrapper">
      <div class="worker-row__name">
        <div class="user">
          <div v-if="worker.photo" v-viewer class="user__pic cursor-pointer">
            <img :src="worker.photo" alt="" />
          </div>
          <div v-else class="user__pic">
            <img :src="placeholder" alt="" />
          </div>

          <router-link
            class="user__name"
            :to="{
              name: 'personal-employee-summary',
              params: { id: worker.id },
            }"
          >
            {{ worker.name }}
          </router-link>
        </div>
      </div>

      <div class="worker-row__periods">
        <div v-if="canEdit" class="worker-row__actions" :data-worker-id="worker.id">
          <div v-for="(d, i) in days" :key="i" class="worker-row__action">
            <button type="button" :data-date="d.date" :data-worker-id="worker.id" data-event="add-period"></button>
          </div>
        </div>

        <div v-if="!periodGroups.length" class="worker-row__period">
          <div
            v-for="(d, i) in days"
            :key="i"
            class="worker-row__day"
            :class="{ 'worker-row__day--off': d.dayOff }"
          ></div>
        </div>

        <div v-for="periodGroup in periodGroups" :key="periodGroup.id" class="worker-row__period">
          <div
            v-for="(d, i) in days"
            :key="i"
            class="worker-row__day"
            :class="{
              'worker-row__day--off': d.dayOff,
            }"
          >
            <template v-for="period in periodGroup.periods">
              <div
                v-if="period.startCell === i"
                :key="period.id"
                class="vacation"
                :class="'vacation-' + period.category"
                :style="{
                  'width': `calc(${period.duration * 100 + '%'} - 1px)`,
                  'min-width': `calc(${period.duration * 100 + '%'} - 1px)`,
                  'color': period.color,
                }"
              >
                <div
                  class="vacation-border"
                  :data-period-id="period.id"
                  :data-worker-id="worker.id"
                  :data-event="'edit-period'"
                ></div>
                <div class="vacation__wrapper">
                  <template v-if="period.file">
                    <svg-icon class="vacation__file" name="clip" :size="14"></svg-icon>
                  </template>
                  <span class="vacation__name">
                    {{ period.category === "sick" ? "Больничный" : period.name }}
                  </span>
                  <span style="white-space: nowrap">
                    <span class="vacation__duration"> {{ period.totalDuration }} дн. </span>
                    <span class="vacation__dates"> {{ period.from }} – {{ period.to }} </span>
                  </span>
                </div>

                <div class="vacation__gradient"></div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import placeholder from "@/assets/images/userpic.svg";
import SvgIcon from "@/components/svg-icon";

let unique = 1;

export default {
  components: { SvgIcon },
  props: ["worker", "days", "canEdit", "showAll"],

  data() {
    return {
      placeholder,
      periodGroups: [],
    };
  },

  watch: {
    "days": function () {
      this.setPeriods();
    },
    "worker.vacations": function () {
      this.setPeriods();
    },
  },

  mounted() {
    this.setPeriods();
  },

  methods: {
    setPeriods() {
      if (!this.days.length) {
        this.periods = [];
        return;
      }
      const periodFirstDay = this.days[0];
      const periodLastDay = this.days[this.days.length - 1];

      const periods = this.worker.vacations.map((pData) => {
        const period = {
          ...pData,
          startCell: -1,
          duration: 0,
          totalDuration: 0,
        };
        const vacationFrom = moment(period.from_dt, "YYYY-MM-DD");

        if (vacationFrom.isAfter(periodLastDay.date)) {
          return period;
        }

        const vacationTo = moment(period.to_dt, "YYYY-MM-DD");

        if (vacationTo.isBefore(periodFirstDay.date)) {
          return period;
        }

        period.fromDate = vacationFrom;
        period.toDate = vacationTo;

        period.from = vacationFrom.format("DD.MM.YYYY");
        period.to = vacationTo.format("DD.MM.YYYY");

        period.startCell = 0;

        if (vacationFrom.isAfter(periodFirstDay.date)) {
          period.startCell = this.days.findIndex((day) => day.date.isSame(vacationFrom));
        }

        let lastVacationDayInPeriod = this.days.length - 1;

        if (vacationTo.isBefore(periodLastDay.date)) {
          lastVacationDayInPeriod = this.days.findIndex((day) => day.date.isSame(vacationTo));
        }

        period.duration = lastVacationDayInPeriod - period.startCell + 1;
        period.totalDuration = period.toDate.diff(period.fromDate, "days") + 1;

        if (period.type) {
          period.name = period.type.name;
          period.color = period.type.color;
        }

        return period;
      });

      const groups = [];

      periods.forEach((period) => {
        if (!period.fromDate || !period.toDate) return;

        const group = groups.find((group) => {
          const intersectingPeriod = group.periods.find((p) => {
            if (period.fromDate.isAfter(p.toDate)) return false;
            if (period.toDate.isBefore(p.fromDate)) return false;
            return true;
          });
          return !intersectingPeriod;
        });

        if (group) {
          group.periods.push(period);
        } else {
          unique += 1;
          groups.push({
            id: unique,
            periods: [period],
          });
        }
      });

      this.periodGroups = groups;
    },
    addPeriod(day) {
      this.$emit("addPeriod", { start: day.date, worker: this.worker });
    },
    onPeriodClick(period) {
      this.$emit("editPeriod", { period, worker: this.worker });
    },
  },
};
</script>

<style scoped lang="scss" src="./style.scss"></style>
